<app-loader *ngIf="isLoading" [label]="uploadProgress"></app-loader>
<app-dialogue-box [isDialogOpen]="isReportStatusDialogOpen" [title]="dialogTexts.REPORT_STATUS.TITLE"
    [message]="reportStatusDialogMessage" (onClose)="closeReportStatusDialog()"
  [closeButtonText]="dialogTexts.REPORT_STATUS.CLOSE" [confirmButtonText]="reportStatusDialogButtonText">
</app-dialogue-box>

<div class="report-create-report" [formGroup]="form">
  <div class="create-report-type">
    <div class="upload-card-head">
      <div class="title-row">
        <h2>{{ labels.TITLE }}</h2>
        <h2 class="screen-title-green">{{ labels.SUBTITLE }}</h2>
      </div>
    </div>

    <div class="custom-stepper">
      <div class="step" [class.active]="currentStep === 1" [class.done]="currentStep > 1">
        <div class="circle">
          <div class="initial-center">1</div>
        </div>
        <div class="label">{{ commonStepLabels.INITIATE }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="currentStep === 2" [class.done]="currentStep > 2">
        <div class="circle">
          <div class="initial-center">2</div>
        </div>
        <div class="label">{{ commonStepLabels.ANALYZED }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="currentStep === 3" [class.done]="currentStep > 3">
        <div class="circle">
          <div class="initial-center">3</div>
        </div>
        <div class="label">{{ commonStepLabels.REVIEW }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="currentStep === 4">
        <div class="circle">
          <div class="initial-center">4</div>
        </div>
        <div class="label">{{ commonStepLabels.APPROVED }}</div>
      </div>
    </div>
  </div>

  <div class="report-form">
    <div class="uploads-block">
      <div class="uploads">
        <div class="upload-group">
          <label class="drop" [class.drag-over]="isReportDragOver" (dragover)="onDropZoneDragOver($event, 'report')"
            (dragleave)="onDropZoneDragLeave($event, 'report')" (drop)="onReportDrop($event)">
            <span class="drop-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
                <path d="M14 3v5h5M9 13h6M9 17h4" />
              </svg>
            </span>
            <span class="drop-body">
              <span class="drop-title">{{ labels.PRIOR_REPORT_TITLE }} <span class="required">*</span></span>
              <span class="drop-sub">{{ labels.PRIOR_REPORT_SUBTITLE }}</span>
              <span class="filename">{{ reportFile?.name || labels.NO_FILE_SELECTED }}</span>
            </span>
            <input type="file" accept=".docx,.dotx" (change)="onReportSelected($event)" />
          </label>
          <p class="validation-error" *ngIf="reportUploadValidationError">{{ reportUploadValidationError }}</p>
        </div>

        <div class="upload-group">
          <label class="drop" [class.drag-over]="isDataDragOver" (dragover)="onDropZoneDragOver($event, 'data')"
            (dragleave)="onDropZoneDragLeave($event, 'data')" (drop)="onDataDrop($event)">
            <span class="drop-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
              </svg>
            </span>
            <span class="drop-body">
              <span class="drop-title">{{ labels.DATA_FILES_TITLE }} <span class="required">*</span></span>
              <span class="drop-sub">{{ labels.DATA_FILES_SUBTITLE }}</span>
              <span class="filename">{{ dataFileNames }}</span>
            </span>
            <input type="file" accept=".xlsx,.xls,.csv" (change)="onDataSelected($event)" />
          </label>
          <p class="validation-error" *ngIf="dataUploadValidationError">{{ dataUploadValidationError }}</p>
        </div>
      </div>
    </div>

    <div class="report-period">
      <div class="add-head">
        <h4>{{ labels.REPORT_PERIOD_TITLE }}</h4>
        <span>{{ labels.REPORT_PERIOD_HINT }}</span>
      </div>

      <div class="period-row">
        <div class="field-group">
          <app-searchable-dropdown [label]="labels.DURATION_LABEL" [items]="durationOptions" bindLabel="label" bindValue="value"
            [placeholder]="labels.DURATION_PLACEHOLDER" formControlName="duration" [showRequired]="true"></app-searchable-dropdown>
        </div>

        <div class="field-group">
          <label class="field-label">{{ labels.START_MONTH_YEAR_LABEL }}  <span class="required">*</span></label>
          <app-month-picker formControlName="startMonthYear"></app-month-picker>
        </div>
      </div>
    </div>
    <div class="additional-block">
      <div class="add-head">
        <h4>{{ labels.ADDITIONAL_SECTIONS_TITLE }}</h4>
        <span>{{ labels.ADDITIONAL_SECTIONS_HINT }}</span>
      </div>

      <div class="additional-list">
        <div class="add-row" *ngFor="let row of additionalSections; let i = index">
          <input class="add-text" type="text"
            [placeholder]="labels.SECTION_LABEL_PLACEHOLDER" [value]="row.label"
            (input)="onSectionLabelChange($event, i)" />

          <div class="add-file-row">
            <div class="add-file-group">
              <label class="add-file" for="sectionFile{{ i }}">
                <span class="add-file-btn">{{ labels.CHOOSE_PDF }}</span>
                <input id="sectionFile{{ i }}" class="add-file-input" type="file" accept="application/pdf,.pdf"
                  (change)="onAdditionalFileSelected($event, i)" />
                <span class="add-file-name" [class.has]="row.file">{{ row.file?.name || labels.NO_FILE_SELECTED }}</span>
              </label>
              <p class="validation-error additional-validation-error"
                *ngIf="row.validationError && !isSectionLabelValidationError(row.validationError)">
                {{ row.validationError }}
              </p>
            </div>

            <button class="add-remove" type="button" [title]="labels.REMOVE_SECTION_TITLE" (click)="removeAdditionalRow(i)"
              [disabled]="additionalSections.length === 1">
              {{ labels.REMOVE_SECTION_BUTTON }}
            </button>
          </div>

          <p class="validation-error additional-validation-error"
            *ngIf="row.validationError && isSectionLabelValidationError(row.validationError)">
            {{ row.validationError }}
          </p>
        </div>
      </div>

      <button class="aecom_btn" type="button" (click)="addAdditionalRow()" [disabled]="additionalSections.length >= 8">{{ labels.ADD_SECTION_BUTTON }}</button>
    </div>

    <div class="report-details">
      <div class="add-head">
        <h4>{{ labels.REPORT_DETAILS_TITLE }}</h4>
        <span>{{ labels.REPORT_DETAILS_HINT }}</span>
      </div>
      <div class="details-row">
        <div class="field-group">
          <label class="field-label">{{ labels.REPORT_NAME_LABEL }} <span class="required">*</span></label>
          <input class="field-input" type="text" [placeholder]="labels.REPORT_NAME_PLACEHOLDER" formControlName="reportName" />
        </div>

        <div class="field-group">
          <app-searchable-dropdown [label]="labels.REPORT_TYPE_LABEL" [items]="reportTypes()" bindLabel="reportTypeName" bindValue="id"
            [placeholder]="labels.REPORT_TYPE_PLACEHOLDER" formControlName="reportType" [showRequired]="true"></app-searchable-dropdown>
        </div>

        <div class="field-group">
          <label class="field-label">{{ labels.PROJECT_ID_LABEL }} <span class="required">*</span></label>
          <input class="field-input" numbersOnly type="numeric" [placeholder]="labels.PROJECT_ID_PLACEHOLDER" formControlName="projectId"
            maxlength="8" />
        </div>

        <div class="upload-actions upload-actions--inline">
          <button type="button" class="aecom_btn--solid" [disabled]="isAnalyzeDisabled" (click)="onAnalyzeReport()">
            {{ labels.ANALYZE_REPORT_BUTTON }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>